import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppBar, AppBarSection, AppBarSpacer } from '@progress/kendo-react-layout';
import { useNavigate } from 'react-router-dom';
import EditUserForm from './EditUserForm';
import { Button, Menu, MenuItem } from '@mui/material'
import { getEmblem } from '../actions';
import { authLogout } from '../store/actions/authActions';


export const Header = (props) => {
  const dispatch = useDispatch();

  const { token, user } = useSelector(state => state.authReducer);
  const [openForm, setOpenForm] = useState(false);
  const [userInfo, setUserInfo] = useState({ email: "", password: 1 });
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const navigate = useNavigate();
  const handleSubmit = (event) => {
    //Save here
  };

  const handleCancelEdit = () => {
    setOpenForm(false);
  };

  return (
    <AppBar className='header'>
      <AppBarSection>
        <img src={`https://collaboration.alastar.com/${user.site.name.toLowerCase()}_emblem.png`} style={{ width: "50px", height: "50px" }} />
      </AppBarSection>

      <AppBarSpacer style={{ width: 4 }} />

      <AppBarSection>
        <h1 style={styles.title}>{`Alastar Collaboration Admin - ${user.site.name}`}</h1>
      </AppBarSection>

      <AppBarSpacer style={{ width: 32 }} />

      <AppBarSection>
        <ul style={styles.appBarUL}>
          <li style={styles.listBtn} onClick={() => props.selectTab({ selected: 0 })}><span>Users</span></li>
          <li style={styles.listBtn} onClick={() => props.selectTab({ selected: 1 })}><span>Groups</span></li>
          <li style={styles.listBtn} onClick={() => props.selectTab({ selected: 2 })}><span>Posts</span></li>
          <li style={styles.listBtn} onClick={() => props.selectTab({ selected: 3 })}><span>About</span></li>
        </ul>
      </AppBarSection>

      <AppBarSpacer />

      <AppBarSection>
        <span className="k-appbar-separator" />
      </AppBarSection>

      <AppBarSection>
        <Button
          id="basic-button"
          aria-controls="basic-menu"
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
        >
          <span style={{ color:'#3f51b5' }} className="k-icon k-i-user"></span>
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          // MenuListProps={{
          //   'aria-labelledby': 'basic-button'
          // }}
          // sx={{ '& .MuiMenu-root': 'block !important' }}
        >
          <MenuItem 
            onClick={() => {
              dispatch(authLogout);
            }}>
            Logout
          </MenuItem>
        </Menu>
        {openForm && (
          <EditUserForm
            cancelEdit={handleCancelEdit}
            onSubmit={handleSubmit}
            item={userInfo}
          />)}
      </AppBarSection>
    </AppBar>
  );
};

const styles = {
  title: {
    fontSize: '18px',
    margin: 0,
  },
  appBarUL: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
  },
  listBtn: {
    margin: '0 10px',
  }
}